import styled from 'styled-components'
import ImgLidoBrand from '~/assets/images/lido-brand.png'

const StyledBrandWatermark = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 20px;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #7f8294;
`

const BrandWatermark = () => {
  return (
    <StyledBrandWatermark>
      Powered by
      <img src={ImgLidoBrand.src} alt="Lido brand" width={60} height={14} />
    </StyledBrandWatermark>
  )
}

export default BrandWatermark
